export default __webpack_public_path__ + "static/media/generic-logo.fa224ce8.svg";